import { render, staticRenderFns } from "./index.vue?vue&type=template&id=98ba4134&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "./index.vue?vue&type=style&index=0&id=98ba4134&prod&lang=scss&scoped=true"
import style1 from "./index.vue?vue&type=style&index=1&id=98ba4134&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_babel-co_fdc8552a8ede636d403bf9928f1c7af2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98ba4134",
  null
  
)

export default component.exports